import Icon from '../components/Icon.vue'

Icon.register({
  'fist-raised': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M256 160V16C256 7.2 248.8 0 240 0H208C199.1 0 192 7.2 192 16V162.9C197 161.1 202.3 160 207.9 160H256zM384 256C384 220.7 355.3 192 320 192H207.8C199.1 192 191.9 199.1 191.9 207.8V208.4C191.9 234.7 213.3 256 239.5 256H274.8C284.5 256 288 259.6 288 264V280.2C288 284.5 284.4 288 280.1 288.2 235.6 290.5 215.9 312.9 184.1 360.8L177.7 370.2A8-8 0 0 0 166.7 372.4L153.3 363.6A8-8 0 0 0 151.1 352.5L157.4 343C173.2 319.4 187.6 299.7 204.7 284.9 187.5 279.4 173.3 266.8 165.9 250.5 159.3 253.9 151.9 256 144 256H112C99.7 256 88.5 251.2 80 243.5 71.5 251.2 60.3 256 48 256H16C10.4 256 5 254.8 0 253.1V331C0 364.9 13.5 397.5 37.5 421.5L64 448V512H320V448L355.9 412.1A96-96 0 0 1 384 344.2L384 256zM352 165.9V48C352 39.2 344.8 32 336 32H304C295.1 32 288 39.2 288 48V160H320C331.3 160 341.9 162.3 352 165.9zM16 224H48C56.8 224 64 216.8 64 208V80C64 71.2 56.8 64 48 64H16C7.2 64 0 71.2 0 80V208C0 216.8 7.2 224 16 224zM112 224H144C152.8 224 160 216.8 160 208V48C160 39.2 152.8 32 144 32H112C103.2 32 96 39.2 96 48V208C96 216.8 103.2 224 112 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fist-raised.js
// module id = ZTws
// module chunks = 144